var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisacard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 13,
    viewBox: "0 0 41 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7641_23328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7666 12.8124H14.4453L16.5227 0.228027H19.8438L17.7666 12.8124Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8067 0.535766C29.1516 0.281139 28.1126 0 26.8278 0C23.5479 0 21.2382 1.71352 21.2241 4.16335C21.1968 5.97082 22.8777 6.97474 24.1349 7.5774C25.4198 8.19324 25.8566 8.5952 25.8566 9.14413C25.8436 9.98719 24.8183 10.3758 23.8621 10.3758C22.5361 10.3758 21.8256 10.1754 20.7459 9.70641L20.3085 9.50534L19.8438 12.3303C20.6227 12.6779 22.0579 12.9865 23.5479 13C27.0328 13 29.3016 11.313 29.3285 8.70232C29.3418 7.26975 28.4542 6.17207 26.5406 5.27509C25.379 4.69929 24.6676 4.31103 24.6676 3.72189C24.6812 3.1863 25.2693 2.63772 26.5806 2.63772C27.6603 2.61085 28.4536 2.86513 29.0546 3.11957L29.355 3.2532L29.8067 0.535766Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2206 8.35419C34.4941 7.63123 35.5466 4.83319 35.5466 4.83319C35.5328 4.86006 35.8196 4.09689 35.9836 3.62838L36.2157 4.71273C36.2157 4.71273 36.8447 7.725 36.9812 8.35419C36.4622 8.35419 34.8766 8.35419 34.2206 8.35419ZM38.3203 0.228027H35.7513C34.9591 0.228027 34.3572 0.45543 34.0154 1.27216L29.082 12.8122H32.567C32.567 12.8122 33.1407 11.259 33.264 10.9245C33.6463 10.9245 37.0364 10.9245 37.5283 10.9245C37.6236 11.3663 37.9246 12.8122 37.9246 12.8122H40.9998L38.3203 0.228027Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6726 0.228027L8.41999 8.80935L8.06456 7.06895C7.46321 5.06077 5.57727 2.87892 3.47266 1.79404L6.45195 12.799H9.96412L15.1846 0.228027H11.6726Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39829 0.228027H0.0546674L0 0.482298C4.16836 1.5266 6.92899 4.04386 8.06321 7.06949L6.90156 1.28586C6.71032 0.48212 6.12259 0.25454 5.39829 0.228027Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7641_23328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 13,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisacard);
export default __webpack_public_path__ + "static/media/visacard.9d0e9db8.svg";
export { ForwardRef as ReactComponent };